import { forwardRef } from 'react';
import { Link } from 'react-router';
import Pill from '../../../../Components/Dashboard/Pill';
import styles from '../dashboardCards.module.css';

const TONE = { Completed: 'good', Assigned: 'info', Declined: 'neutral' };

const PastWorkoutRow = forwardRef(({ row, saving, onComplete, calendarPath }, detailsRef) => {
    const [dow, day] = row.dateLabel.split(' ');
    return (
        <li>
            <div className={styles.pwRow}>
                <div className={styles.dayTile} aria-hidden="true">
                    {dow}
                    <b>{day}</b>
                </div>
                <div className={styles.pwInfo}>
                    <div className={styles.pwLine}>
                        <b>{`${row.dateLabel} · ${row.time}`}</b>
                        <Pill tone={TONE[row.status]}>{row.status}</Pill>
                    </div>
                    <small>{row.detail}</small>
                </div>
                <div className={styles.pwAct}>
                    {row.canComplete && (
                        <button
                            type="button"
                            className={styles.btn}
                            aria-label={`Mark completed: ${row.dateLabel} session`}
                            aria-disabled={saving ? 'true' : undefined}
                            onClick={() => !saving && onComplete(row.id)}
                        >
                            {saving ? 'Saving…' : 'Mark completed'}
                        </button>
                    )}
                    <Link
                        ref={detailsRef}
                        to={calendarPath}
                        className={styles.iconLink}
                        aria-label={`Details for ${row.dateLabel} session`}
                    >
                        <span aria-hidden="true">⋯</span>
                    </Link>
                </div>
            </div>
        </li>
    );
});

export default PastWorkoutRow;
